import neverLandGameData from "../../utils/NeverLandGameData";
import {useEffect, useState} from "react";
import React from 'react';
import soccerIcon from "../../assets/images/icon_soccer.png"
import baseballIcon from "../../assets/images/icon_baseball.png"
import volleyballIcon from "../../assets/images/icon_volleyball.png"
import basketballIcon from "../../assets/images/icon_basketball.png"
import neverLandUtils from "../../utils/NeverLandUtils";
import {toast} from "react-toastify";
import {accountInfo, getImage} from "../../constants/constants";
import {ModalHandler, OpenModalHandle} from "../Modal/Generic/ModalHandler";
import {getFetcherAnalysis} from "../../utils/fetcher_gameAnlysis";
import {GET_GAME_ANALYSIS_DATA_API} from "../../constants/api_constants";
import {RiLock2Fill} from "react-icons/ri";
import {MAIN_PAGE} from "../../constants/page_constants";

export const getGameLogoImgURL = (category) => {
  if (category === 'SC') return soccerIcon;
  if (category === 'BK') return basketballIcon;
  if (category === 'VL') return volleyballIcon;
  if (category === 'BS') return baseballIcon;
}

const GameCardLargeFont = ({
                             setMouseOverData,
                             setShowGameAnalysisModal,
                             setAnalysisType,
                             setGameId
                           }) => {
  const [index, setIndex] = useState(0);
  const [dataInfo, setDataInfo] = useState({dataId: null, requestDate: null});
  const OpenModal = OpenModalHandle.create();

  const updateUI = () => {
    setIndex(prevState => prevState + 1);
  }
  const handleOnChanged = () => {
    updateUI();
  };

  useEffect(() => {
    neverLandGameData.addOnChangedHandler(handleOnChanged);
    neverLandGameData.loadGameDataList("game_card");
    return () => {
      neverLandGameData.removeOnChangedHandler(handleOnChanged);
    }
  }, [])

  const _toggleSelectItem = (parentGameInfo, thisGameData, id, key) => {
    // 조건부로 버튼 안먹히게
    if (parentGameInfo.state !== "발매중")
      return;
    if (key === "d" && ((thisGameData.extraText !== 'H' || thisGameData.draw === '0.00') && thisGameData.extraText !== '무'
        && thisGameData.extraText !== '⑤'
        && thisGameData.extraText !== '①'))
      return;
    if (neverLandGameData.toggleSelectItem(id, key)) {
      return;
    }
    toast.warn('10경기 이상 선택할 수 없습니다.');
  }

  function isLockState(buttonData, selection) {
    // 버튼 잠금 여부 결정
    let selectionFlag = 0;
    // 배당이 1.0일때 버튼 잠그기
    if (selection === 'w') {
      if (buttonData.win === '1.00') {
        return true;
      }
      selectionFlag = 1 << 0;
    }
    if (selection === 'd') {
      if (buttonData.draw === '1.00') {
        return true;
      }
      selectionFlag = 1 << 1;
    }
    if (selection === 'l') {
      if (buttonData.lose === '1.00') {
        return true;
      }
      selectionFlag = 1 << 2;
    }

    let lockState = buttonData.lockState !== null ? parseInt(buttonData.lockState, 10) : 0;
    let lockStateByAdmin = buttonData.lockStateByAdmin !== null ? parseInt(buttonData.lockStateByAdmin, 10) : 0;

    if (lockState & selectionFlag) {
      return true;
    }
    if (lockStateByAdmin & selectionFlag) {
      return true;
    }
    return false;
  }

  const onClickAnalysisButton = (game) => {
    // 경기분석 버튼 클릭 시
    setDataInfo({
      dataId: game.dataId,
      requestDate: new Date(),
      analysisType: game.isPreviewData ? 'lineup' : 'report',
    });

    setGameId(game.dataId);

    // analysisType 설정
    if (game.isPreviewData) {
      setAnalysisType('lineup');  // 라인업 있는 경기
    } else {
      setAnalysisType('report');  // 분석 버튼 (라인업 없는 경기)
    }
  };

  let use_magnifier_mode = accountInfo.getUserConfig().isOn('use_magnifier_mode', false);

  const getDisplayButtonText = (category, extraText, type) => {
    const textMap = type === "승"
        ? {"U/O": "U", "SUM": "홀", "default": "승"}
        : {"U/O": "O", "SUM": "짝", "default": "패"};

    const resultText = textMap[extraText] || textMap["default"];

    // 카테고리가 type01 이면 전반 붙이기
    return category === "type01" && (resultText === "U" || resultText === "승" || resultText === "O" || resultText === "패")
        ? `(전)${resultText}` : resultText;
  };

  const replaceState = (state) => {

    return state === "null" ? "준비중" :
        state === "발매전" ? "배팅전" :
            state === "발매중" ? "배팅중" :
                state === "발매종료" ? "배팅종료" : state;
  }

  return (
      <>
        <ModalHandler path={MAIN_PAGE} initModalHandle={OpenModal}/>

        <div>
          <ul role="list" className="flex flex-wrap justify-center items-stretch gap-3">
            {neverLandGameData.getFilteredGameData()?.map((game, index) => {
              // 데이터 유효성 검사
              if (game.closingDate === "-") {
                return null;
              }

              return (
                  <React.Fragment key={index}>
                    <li className="col-span-1 divide-y divide-gray-400 rounded-lg bg-white text-center shadow overflow-hidden max-w-[22rem] min-w-[18rem]">
                      {/* <------- 상단 경기 정보 -------> */}
                      <div className="flex flex-1 flex-row justify-between px-3 py-2 text-lg items-center">
                        {/* 경기 리그 */}
                        <div className="flex flex-row items-center">
                          <img src={getGameLogoImgURL(game.category)}
                               className={neverLandUtils.classNames(game.category === 'BS' ? "h-6 w-6" : "h-5 w-5", "mx-2")}/>
                          <p className="font-semibold">{game.leagueName}</p>
                        </div>

                        {/* 경기 시간 */}
                        <p className="text-gray-500">{neverLandGameData.formatDate(game.closingDate)}</p>

                        <div className="flex items-center">
                          {game.isDoubleHeader && // 더블헤더일때 (같은날에 같은 홈팀 vs 원정팀 두번 경기)
                              <span
                                  className="inline-flex items-center rounded-full px-2 py-1 text-xs bg-fuchsia-600 text-white font-bold whitespace-nowrap mr-2">
                                    더블헤더
                              </span>
                          }

                          {game.state === '50' ? // 게임 잠금
                              <span
                                  className="inline-flex items-center rounded-full px-2 py-1 text-xs font-medium bg-red-100 text-red-700">
                              <RiLock2Fill className="h-5 w-auto"/>
                              </span>
                              : <span
                                  className={`inline-flex items-center rounded-full px-2 py-1 text-xs font-medium shadow-md text-white
                              ${game.state === "발매중" ? "bg-rose-700 border border-rose-800" : "bg-stone-800"} `}
                              >
                                {replaceState(game.state)}
                              </span>
                          }
                        </div>
                      </div>

                      <div className="text-md flex flex-1 flex-row justify-center py-3">
                        <table className="table-fixed w-full">
                          <thead>
                          <tr className="text-xl whitespace-nowrap">
                            <th scope="col" className="w-1/4 items-center">
                              {/* 경기분석 버튼 FIXME: 야구 빼고 띄움 */}
                              {game.category !== 'BS' && (game.isPreviewData ?
                                  // 라인업 있는 경기 (금장 라인업 버튼)
                                  <button onClick={() => {
                                    setShowGameAnalysisModal(true);
                                    onClickAnalysisButton(game);
                                  }}>
                                    <img src={getImage('lineup_button')}
                                         className="w-12 h-auto text-white items-center" alt='button'/>
                                  </button>
                                  :
                                  // 라인업 없는 경기 (은색 분석 버튼)
                                  <button onClick={() => {
                                    setShowGameAnalysisModal(true);
                                    onClickAnalysisButton(game);
                                  }}
                                  >
                                    <img src={getImage('analysis_button')}
                                         className="w-11 h-auto text-white items-center" alt='button'/>
                                  </button>)
                              }
                            </th>
                            <th scope="col" className="w-1/4">{game.homeTeam}</th>
                            <th scope="col" className="w-1/4">vs</th>
                            <th scope="col" className="w-1/4">{game.awayTeam}</th>
                          </tr>
                          </thead>

                          {/* <---------- 버튼 영역 ----------> */}
                          <tbody>
                          {game.data?.map((buttonData) => {
                            if (neverLandGameData.isFilteredGameAllotData(buttonData.extraText)) {
                              return null;
                            }
                            if (game.state === "null") return null;
                            return (
                                <tr key={buttonData.allotId}>
                                  {/* <- 경기번호 버튼 -> */}
                                  <td className="flex justify-center">
                                    <div
                                        className="game-card-btn-custom game-number large-font">
                                      <p>{buttonData.gameNo.replace("ⓢ", "")}</p>
                                      <p className="text-amber-300 font-semibold ml-1">{buttonData.gameNo.includes("ⓢ") ? "ⓢ" : ""}</p>
                                    </div>
                                  </td>

                                  {/* <- 승 버튼 -> */}
                                  <td className="w-full"
                                      onMouseOver={() => {
                                        if (use_magnifier_mode && setMouseOverData)
                                          setMouseOverData({
                                            displayTitle: game.homeTeam + " vs " + game.awayTeam,
                                            dataType: 'win',
                                            displayData: buttonData
                                          });
                                      }}
                                      onMouseLeave={() => {
                                        if (use_magnifier_mode && setMouseOverData)
                                          setMouseOverData(null);
                                      }}
                                  >
                                    <div className="flex w-full">
                                      {buttonData.win === "0.00" ?
                                          <div className='game-card-btn-custom large-font'> - </div>
                                          :
                                          <button
                                              disabled={isLockState(buttonData, 'w')}
                                              onClick={() => _toggleSelectItem(game, buttonData, buttonData.allotId, 'w')}
                                              className="flex-1 relative"
                                          >
                                            {isLockState(buttonData, 'w') &&
                                                <RiLock2Fill
                                                    className="h-6 w-auto text-white bg-zinc-600 p-1 rounded-full absolute top-0 left-0.5 z-10"/>}
                                            <div className={`${isLockState(buttonData, 'w') ? 'lock-state' :
                                                neverLandGameData.isSelected(buttonData.allotId, 'w') ? 'selected-state' : ''} 
                                              flex flex-col game-card-btn-custom large-font`}
                                            >
                                              {getDisplayButtonText(buttonData.category, buttonData.extraText, "승")}
                                              <br/> {buttonData.win}
                                            </div>
                                          </button>
                                      }
                                    </div>
                                  </td>

                                  {/* <- 무 버튼 -> */}
                                  <td className="w-full"
                                      onMouseOver={() => {
                                        if (use_magnifier_mode && setMouseOverData)
                                          setMouseOverData({
                                            displayTitle: game.homeTeam + " vs " + game.awayTeam,
                                            displayData: buttonData,
                                            dataType: 'draw'
                                          });
                                      }}
                                      onMouseLeave={() => {
                                        if (use_magnifier_mode && setMouseOverData)
                                          setMouseOverData(null);
                                      }}
                                  >
                                    <div className="flex w-full">
                                      {(parseFloat(buttonData.draw) === 0 && buttonData.extra === '0.0' && buttonData.extraText !== 'SUM' || buttonData.extraText === null) ?
                                          // 무 배당이 0.00 이면 버튼 - 으로 표시
                                          <div className='game-card-btn-custom large-font'> - </div>
                                          :
                                          ((buttonData.extraText == null || buttonData.extraText === "null") ? "-" :
                                                  <button
                                                      disabled={isLockState(buttonData, 'd')}
                                                      onClick={() => _toggleSelectItem(game, buttonData, buttonData.allotId, 'd')}
                                                      className="flex-1 relative"
                                                  >
                                                    {isLockState(buttonData, 'd') &&
                                                        <RiLock2Fill
                                                            className="h-6 w-auto text-white bg-zinc-600 p-1 rounded-full absolute top-0 left-0.5 z-10"/>}
                                                    <div className={neverLandUtils.classNames(
                                                        isLockState(buttonData, 'd') ? 'lock-state' :
                                                            neverLandGameData.isSelected(buttonData.allotId, 'd') ? 'selected-state large-font' : '',
                                                        // 핸디가 아니거나 배당이 0이면서 무, ①, ⑤이 아닌 경우
                                                        ((buttonData.extraText !== 'H' || parseFloat(buttonData.draw) === 0)
                                                            && buttonData.extraText !== '무'
                                                            && buttonData.extraText !== '⑤'
                                                            && buttonData.extraText !== '①') ? 'disabled-state' : '', 'game-card-btn-custom large-font text-xs'
                                                    )}>
                                                      {
                                                        // 무, 승일패(①), 승오패(⑤)인 경우
                                                        (buttonData.extraText === '무' || buttonData.extraText === '①' || buttonData.extraText === '⑤') ?
                                                            <div className="flex flex-col">
                                                              <p>
                                                                {buttonData.extraText === '무' && buttonData.category === 'type01' ? '(전)' : ''}
                                                                {buttonData.extraText}
                                                              </p>

                                                              <div
                                                                  className="flex flex-row items-center w-full justify-center mt-2">
                                                                {/*경기 배당*/}
                                                                <p>{buttonData.draw}</p>
                                                              </div>
                                                            </div>

                                                            // 핸디면서 배당이 0이 아닐때
                                                            : buttonData.extraText === 'H' && parseFloat(buttonData.draw) !== 0 ?
                                                                <div className="whitespace-nowrap">
                                                                  <p>{"무 " + buttonData.draw}</p>
                                                                  <div
                                                                      className="flex flex-row items-center w-full justify-center mt-2">
                                                                    <p>{buttonData.extraText + (buttonData.extra > 0 ? "+" : " ") + buttonData.extra}</p>
                                                                  </div>
                                                                </div>

                                                                // SUM 일때
                                                                : buttonData.extraText === 'SUM' ?
                                                                    <p className="disabled-state large-font">
                                                                      {buttonData.extraText}
                                                                    </p>

                                                                    : <div className="flex flex-col">
                                                                      <p className="mb-2">{buttonData.extraText}</p>
                                                                      <p>{((buttonData.extraText === 'H' && buttonData.extra > 0) ? "+" : "") + buttonData.extra}</p>
                                                                    </div>
                                                      }
                                                    </div>
                                                  </button>
                                          )}
                                    </div>
                                  </td>

                                  {/* <- 패 버튼 -> */}
                                  <td className="w-full"
                                      onMouseOver={() => {
                                        if (use_magnifier_mode && setMouseOverData)
                                          setMouseOverData({
                                            displayTitle: game.homeTeam + " vs " + game.awayTeam,
                                            displayData: buttonData,
                                            dataType: 'lose'
                                          });
                                      }}
                                      onMouseLeave={() => {
                                        if (use_magnifier_mode && setMouseOverData)
                                          setMouseOverData(null);
                                      }}
                                  >
                                    <div className="flex w-full">
                                      {buttonData.lose === "0.00" ?
                                          <div className='game-card-btn-custom large-font'> - </div>
                                          :
                                          <button
                                              disabled={isLockState(buttonData, 'l')}
                                              className="flex-1 relative"
                                              onClick={() => _toggleSelectItem(game, buttonData, buttonData.allotId, 'l')}
                                          >
                                            {isLockState(buttonData, 'l') && <RiLock2Fill
                                                className="h-6 w-auto text-white bg-zinc-600 p-1 rounded-full absolute top-0 left-0.5 z-10"/>}
                                            <div className={`${isLockState(buttonData, 'l') ? 'lock-state' :
                                                neverLandGameData.isSelected(buttonData.allotId, 'l') ? 'selected-state' : ''} 
                                                flex flex-col game-card-btn-custom large-font`}
                                            >
                                              <p>{getDisplayButtonText(buttonData.category, buttonData.extraText, "패")}</p>
                                              <div className="flex flex-row items-center w-full justify-center">
                                                <p>{buttonData.lose}</p>
                                              </div>
                                            </div>
                                          </button>
                                      }
                                    </div>
                                  </td>
                                </tr>
                            );
                          })}
                          </tbody>
                        </table>
                      </div>
                    </li>
                  </React.Fragment>
              );
            })}
          </ul>
        </div>
      </>
  )
}
export default GameCardLargeFont;
